export default class AuthService{
  constructor(server, $state){
    this.server = server;
    this.user = null;
    this.nextState = null;
    this.$state = $state;
  }

  get isLoggedIn(){
    return this.user !== null;
  }

  autologin(){
    return this.server("getUser").then(user => this.session(user));
  }

  keepalive(){
    return this.server("getUser").then(user => user, err => null).then(user => {
      if(!user){
        this.user = null;
        if(this.$state) this.$state.go("login");
      }else if(!this.user){
        this.session(user);
      }
    });
  }

  logout(){
    if(this.$state) this.$state.go("login");
    this.login();
  }

  login(username, password){
    try{
      if(window.localStorage && window.localStorage.removeItem){
        window.localStorage.removeItem("antes.projekt.list.filter");
      }
    }catch(e){}
    return this.server("login", {username: username, password: password}).then(user => this.session(user));
  }

  hasRole(roleId){
    if(this.user && this.user.role){
      return !!this.user.role.find(role => role.id == roleId);
    }
    return false;
  }

  can(permission){
    if(this.user && this.user.permissions){
      return !!this.user.permissions.find(p => p === permission);
    }
    return false;
  }

  resume(){
    if(this.nextState && this.nextState.name() != "login"){
      if(this.$state) this.$state.go(this.nextState.name(), this.nextState.params());
    }else{
      if(this.$state) this.$state.go("home");
    }
    this.nextState = null;
  }

  /* starts user session */
  session(user){
    console.log("starting session for", user);
    if(user){
      this.user = user;
    }else{
      this.user = null;
    }
    this.resume();
    return user;
  }


}


// WEBPACK FOOTER //
// ./src/auth/AuthService.js